import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const CreateNewTriPartyMOU = React.lazy(() => import('./CreateNewTriPartyMOU'));

const TriPartyMouPage: React.FC = () => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>
            {drawer?._Key === 'CreateNewTriPartyMOU' && <CreateNewTriPartyMOU />}
        </Box>
    )
}

export default TriPartyMouPage